import React from "react";

/**
 * The revision pill beside the item header.
 *
 * Three states, and the third is the point of it: a component whose spec is
 * governed by an in-house part shows a link through to that part instead of a
 * revision of its own, so nobody edits the pool thinking they are editing the
 * drawing.
 */
export default function ComponentRevisionBadge({ component, onNewRevision, busy }) {
  if (!component) return null;

  if (component.spec_owner === "part" && component.governing_part) {
    const part = component.governing_part;
    return (
      <span className="d-inline-flex align-items-center gap-2 ms-2">
        <a
          href={`/parts?part_id=${part.part_id}`}
          className="badge bg-info text-dark text-decoration-none"
          title="This component is a stock pool for an in-house part. Its drawings and revisions live there."
        >
          Governed by part {part.product_id} Rev {part.revision_code} →
        </a>
      </span>
    );
  }

  const code = component.current_revision_code;

  return (
    <span className="d-inline-flex align-items-center gap-2 ms-2">
      {code ? (
        <span className="badge bg-dark" title="Current revision of this purchased component">
          Rev {code}
        </span>
      ) : (
        <span className="badge bg-secondary" title="No revision recorded yet">
          no revision
        </span>
      )}
      <button
        type="button"
        className="btn btn-sm btn-outline-dark"
        onClick={onNewRevision}
        disabled={busy}
        title="Freeze the current spec and start a new revision"
      >
        New revision
      </button>
    </span>
  );
}
